import { frontmatter as fm1, content as c1 } from './best-pos-software-2025';
import { frontmatter as fm2, content as c2 } from './best-fb-software-restaurants';
import { frontmatter as fm3, content as c3 } from './top-fb-management-software';
import { frontmatter as fm4, content as c4 } from './dpos-vs-competitors';
import { frontmatter as fm5, content as c5 } from './how-to-choose-pos-software';
import { frontmatter as fm6, content as c6 } from './restaurant-gst-billing-software-india';
import { frontmatter as fm7, content as c7 } from './how-to-choose-restaurant-inventory-software';
import { frontmatter as fm8, content as c8 } from './how-qr-menu-ordering-works-restaurants';
import { frontmatter as fm9, content as c9 } from './kot-printing-for-restaurants';

export const posts = [
  { ...fm1, content: c1 },
  { ...fm2, content: c2 },
  { ...fm3, content: c3 },
  { ...fm4, content: c4 },
  { ...fm5, content: c5 },
  { ...fm6, content: c6 },
  { ...fm7, content: c7 },
  { ...fm8, content: c8 },
  { ...fm9, content: c9 },
].sort((a, b) => new Date(b.date) - new Date(a.date));

export function getPostBySlug(slug) {
  return posts.find(p => p.slug === slug) || null;
}
